import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {HomeComponent} from 'src/app/dashboard/home/home.component';
import {ReceiptsComponent} from 'src/app/dashboard/receipts/receipts.component';
import {AbandonComponent} from 'src/app/dashboard/abandon/abandon.component';
import {MoveComponent} from 'src/app/dashboard/move/move.component';
import {BookkitComponent} from 'src/app/dashboard/bookkit/bookkit.component';
import {StockinsertComponent} from 'src/app/dashboard/stockinsert/stockinsert.component';
import {PartsusageComponent} from 'src/app/dashboard/partsusage/partsusage.component';
import {TransactionsComponent} from 'src/app/dashboard/transactions/transactions.component';
import {UserComponent} from 'src/app/dashboard/user/user.component';


const routes: Routes = [
  {path :'home', component : HomeComponent},
  {path :'receipts', component : ReceiptsComponent},
  {path :'abandon', component : AbandonComponent},
  {path :'move', component : MoveComponent}, 
  {path :'bootkit', component : BookkitComponent}, 
  {path :'stock', component : StockinsertComponent},
  {path :'partsusage', component : PartsusageComponent},
  {path :'transactions', component : TransactionsComponent},
  {path :'user', component : UserComponent},  
  {path: '', redirectTo: '/',pathMatch: 'full'}
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
